import styled from '@emotion/styled'
import React from 'react'
import { useFormContext } from 'react-hook-form'

import { useIntegration } from '../../hooks/useIntegration'
import { usePreviewController } from '../WidgetPreview/previewController'
import CustomColorInput from './CustomColorInput'
import { FormValues } from 'components/forms/ThemeForm'

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-gap: ${({ theme }) => theme.spaces.space4};
	padding-bottom: ${({ theme }) => theme.spaces.space2};
	overflow: hidden;
`

const ExtendedColorsConfiguration = () => {
	const { watch, setValue } = useFormContext<FormValues>()
	const { integration: liveChatIntegration } = useIntegration('livechat')
	const { integration: chatbotIntegration } = useIntegration('chatbot')
	const wrapperRef = React.useRef<HTMLDivElement>(null)
	const previewController = usePreviewController()

	const hasChatIntegration = liveChatIntegration?.connected || chatbotIntegration?.connected

	const visitorMessageColorText = watch('visitorMessageColorText')
	const visitorMessageColorBackground = watch('visitorMessageColorBackground')
	const agentMessageColorText = watch('agentMessageColorText')
	const agentMessageColorBackground = watch('agentMessageColorBackground')
	const minimizedColorIcon = watch('minimizedColorIcon')
	const minimizedColorBackground = watch('minimizedColorBackground')

	const onBlur = (event: React.FocusEvent) => {
		if (wrapperRef.current?.contains(event.relatedTarget)) {
			// do nothing if next focus is one of the color inputs
			return
		}
		previewController.showView('Homescreen')
	}
	const showChat = () => previewController.showView('Chat')
	const showMinimized = () => previewController.minimize()

	return (
		<Grid ref={wrapperRef}>
			{hasChatIntegration && (
				<>
					{(
						[
							{
								label: 'User message',
								value: visitorMessageColorBackground,
								name: 'visitorMessageColorBackground',
							},
							{ label: 'User text', value: visitorMessageColorText, name: 'visitorMessageColorText' },
							{
								label: 'Bot/Agent message',
								value: agentMessageColorBackground,
								name: 'agentMessageColorBackground',
							},
							{ label: 'Bot/Agent text', value: agentMessageColorText, name: 'agentMessageColorText' },
						] as const
					).map(({ label, value, name }) => (
						<CustomColorInput
							key={name}
							label={label}
							value={value}
							onChange={(color) => setValue(name, color, { shouldValidate: true, shouldDirty: true })}
							onFocus={showChat}
							onBlur={onBlur}
						/>
					))}
				</>
			)}
			<CustomColorInput
				label="Bubble"
				value={minimizedColorBackground}
				onChange={(color) => setValue('minimizedColorBackground', color, { shouldValidate: true, shouldDirty: true })}
				onFocus={showMinimized}
				onBlur={onBlur}
			/>
			<CustomColorInput
				label="Icon color"
				value={minimizedColorIcon}
				onChange={(color) => setValue('minimizedColorIcon', color, { shouldValidate: true, shouldDirty: true })}
				onFocus={showMinimized}
				onBlur={onBlur}
			/>
		</Grid>
	)
}

export default ExtendedColorsConfiguration
